module.exports = __webpack_public_path__ + "63abda6fcaf25c09875dca3861495f51.svg";